module.exports = __webpack_public_path__ + "static/media/icon_h1.e7a5136c.svg";